import "./bootstrap";
import "../css/app.css";
import "../css/style.css";

import "sweetalert2/dist/sweetalert2.min.css";
import "vue-select/dist/vue-select.css";

import { createApp, h } from "vue";
import { createPinia } from "pinia";
import { createInertiaApp, Head, Link, router } from "@inertiajs/vue3";
import { ZiggyVue, route } from "../../vendor/tightenco/ziggy";
import { Ziggy } from "./ziggy.js";
Ziggy.url = typeof window !== "undefined" ? window.location.origin : Ziggy.url;
// Expose Ziggy + route() globally so bare `route()` calls in <script setup>
// (not just templates) resolve — matches the bundled-ziggy setup.
if (typeof window !== "undefined") {
  window.Ziggy = Ziggy;
  window.route = route;
}
import VueSweetalert2 from "vue-sweetalert2";
import Container from "./Layouts/Container.vue";
import { setupI18n } from "./i18n";
import { setLocale } from "./i18n/helper";

import vSelect from "vue-select";

import { notification } from "./Plugins/notyf";

// Apply the brand theme from the shared `apps.theme` prop onto <html>.
// The initial value is rendered server-side in app.blade.php (no flash);
// this keeps it in sync after the theme is changed in the backend.
const applyTheme = (theme) => {
  document.documentElement.setAttribute("data-theme", theme || "maroon");
};
router.on("navigate", (event) => {
  applyTheme(event.detail.page.props?.apps?.theme);
});

createInertiaApp({
  title: (title) => `JURUSAN AKUNTANSI  ${title}`,
  resolve: (name) => {
    const pages = import.meta.glob("./Pages/**/*.vue", { eager: true });
    let page = pages[`./Pages/${name}.vue`];

    page.default.layout = page.default.layout || Container;
    return page;
  },
  setup({ el, App, props, plugin }) {
    setupI18n().then((i18n) => {
      // Handle locale initialization more robustly
      const urlParams = new URLSearchParams(window.location.search);
      const urlLocale = urlParams.get("locale");
      const storedLocale = localStorage.getItem("locale");
      let activeLocale;

      // Determine which locale to use
      if (urlLocale && ["en", "id"].includes(urlLocale)) {
        activeLocale = urlLocale;
        console.log(`Using locale from URL parameter: ${urlLocale}`);
      } else if (storedLocale && ["en", "id"].includes(storedLocale)) {
        activeLocale = storedLocale;
        console.log(`Using locale from localStorage: ${storedLocale}`);
      } else {
        activeLocale = "id"; // Default
        console.log(`Using default locale: id`);
      }

      // Pastikan localStorage selalu diupdate
      localStorage.setItem("locale", activeLocale);

      // Set locale pada instance i18n dengan metode yang lebih robust
      try {
        console.log(`Attempting to set i18n locale to: ${activeLocale}`);

        // Cara 1: Legacy mode API
        if (i18n.mode === "legacy") {
          i18n.global.locale = activeLocale;
          console.log(`Set locale using legacy mode: ${activeLocale}`);
        }
        // Cara 2: Composition API
        else {
          i18n.global.locale.value = activeLocale;
          console.log(`Set locale using composition API: ${activeLocale}`);
        }

        // Cara 3: Coba cara lain jika di atas gagal
        if (i18n.global && typeof i18n.global.setLocaleMessage === "function") {
          console.log(
            `Ensuring locale messages are available for: ${activeLocale}`
          );
        }

        // Cara 4: Force jika semua cara gagal
        if (i18n.global) {
          const forceLocaleUpdate = () => {
            try {
              // Broadcast event bahwa locale telah berubah
              window.dispatchEvent(
                new CustomEvent("locale:force", {
                  detail: { locale: activeLocale },
                })
              );
            } catch (e) {
              console.error("Error dispatching locale force event:", e);
            }
          };

          // Jalankan setelah aplikasi dimuat sepenuhnya
          setTimeout(forceLocaleUpdate, 1000);
        }
      } catch (err) {
        console.error(`Error setting locale: ${err.message}`);
        // Jangan sampai kegagalan ini menghentikan aplikasi
      }

      // Log info penting
      console.log(
        `i18n mode: ${i18n.mode}, initialized with locale: ${activeLocale}`
      );
      window.__i18n_init_status = {
        time: new Date().toISOString(),
        mode: i18n.mode,
        initialLocale: activeLocale,
        source: urlLocale ? "URL" : storedLocale ? "localStorage" : "default",
      };

      const app = createApp({ render: () => h(App, props) })
        .use(plugin)
        .use(createPinia())
        .use(VueSweetalert2)
        .use(ZiggyVue, Ziggy)
        .use(notification)
        .use(i18n) // gunakan hasil dari setupI18n
        .component("Head", Head)
        .component("Link", Link)
        .component("v-select", vSelect);

      // Global property for easy access to i18n instance
      app.config.globalProperties.$i18n = i18n.global;

      // Ensure i18n is available globally - ALWAYS
      window.i18n = i18n;
      console.log(
        "i18n instance exposed globally on window.i18n for diagnostics"
      );

      // Broadcast that i18n is ready for any diagnostic tools
      window.dispatchEvent(
        new CustomEvent("i18n:ready", {
          detail: { i18n },
        })
      );

      // Mount the app
      app.mount(el);
    });
  },
  progress: {
    color: "#800000", // maroon
    showSpinner: true,
  },
});
